var exports = {
  "X": "validationErrorTooltip__CrkGq-",
};

module.exports = exports;
